import { createContext, useState } from "react";

export const DarkContext =  createContext();

export const ThemeContext = ({children})=>{
            
    const [theme,setTheme] = useState() 

    


    return(
    <DarkContext.Provider value={[theme,setTheme]}>
            {children}
    </DarkContext.Provider>

    )

}


